import useEntryContent from './useEntryContent';
import location from '../queries/location';

const useLocationContent = locatioName => useEntryContent(`location/${locatioName}`, location);

export default useLocationContent;
